import React from "react";

const DSPosOnOffModal = ({ isOpen, onClose, onConfirm, posIds, action }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl">
        <h2 className="text-xl font-bold mb-4">Confirm {action}</h2>
        <p className="mb-4">
          Are you sure you want to {action.toLowerCase()} {posIds.join(", ")}?
        </p>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-[#FA4B16] text-white rounded hover:bg-[#FA4B16]">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DSPosOnOffModal;
